module.exports = __webpack_public_path__ + "static/media/norte_medio(1).20f557fb.jpg";